import React from 'react';
import { Hero } from '../components/Hero';
import { WhatIsCognarchism } from '../components/WhatIsCognarchism';
import { NCJISection } from '../components/NCJISection';
import { ConstitutionalOrder } from '../components/ConstitutionalOrder';
import { DevelopmentalStatecraft } from '../components/DevelopmentalStatecraft';
export function Home() {
  return <>
      <Hero data-id="element-378" />
      <WhatIsCognarchism data-id="element-379" />
      <NCJISection data-id="element-380" />
      <ConstitutionalOrder data-id="element-381" />
      <DevelopmentalStatecraft data-id="element-382" />
    </>;
}